export default (query = {}) => parseInt(query.page) || 1;
